import { createContext } from 'react';

const defaultValue = {
  data: {},
  serviceVehicle: null,
  setServiceVehicle: () => {},
  editServiceAreas: null,
  setEditServiceAreas: () => {},
  selectedVehicles: null,
  setSelectedVehicles: () => {},
  portalRef: {},
};

export const ServiceAreaContext = createContext(defaultValue);
export const ServiceAreaProvider = ServiceAreaContext.Provider;
export const ServiceAreaConsumer = ServiceAreaContext.Consumer;
